/**
 * Joshua Alele-Beals
 * joshbeals22@gmail.com
 * github.com/joshBeals
 */

import { useState } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import ScenarioMain from "../components/ScenarioMain";
import ScenarioVisual from "../components/ScenarioVisual";
import ScenarioResult from "../components/ScenarioResult";
import { useAppState } from "../store/AppStateContext";

export default function Scenario() {
    const { showResult } = useAppState();

    // 🔴 NEW: explicit solver trigger
    const [shouldRun, setShouldRun] = useState(false);

    return (
        <Container fluid>
            <Row style={{ height: "100vh" }}>
                {/* LEFT PANEL */}
                <Col
                    className="bg-dark p-3"
                    style={{ height: "100%", overflowY: "auto" }}
                >
                    <Alert variant="success">
                        <Alert.Heading>Check Expungement Eligibility</Alert.Heading>
                        <p>
                            Welcome to the Expungement Checker! You can set up your
                            scenario or conviction history and identify eligible
                            convictions for expungement.
                        </p>
                        {/* <hr />
                        <p className="mb-0">Good luck!</p> */}
                    </Alert>

                    <ScenarioMain setShouldRun={setShouldRun} />
                </Col>

                {/* RIGHT PANEL */}
                <Col
                    className="p-3"
                    style={{
                        height: "100%",
                        overflowY: "auto",
                        background: "#f1f4fb",
                    }}
                >
                    <div className="p-5">
                        {showResult ? (
                            <ScenarioResult
                                shouldRun={shouldRun}
                                onRunComplete={() => setShouldRun(false)}
                            />
                        ) : (
                            <ScenarioVisual />
                        )}
                    </div>
                </Col>
            </Row>
        </Container>
    );
}
